import { useCallback, useEffect, useState } from 'react';
import useBrokerApi from '../../api/useBrokerApi';
import { BrokerDetails } from './Broker';
import { defaultBrokerDetails } from './BrokerProvider';

export function useBroker(id: string) {
  const [brokerDetails, setBrokerDetails] = useState<BrokerDetails>(defaultBrokerDetails);
  const { getBrokerUser } = useBrokerApi();

  const fetchBroker = useCallback(async () => {
    const result = await getBrokerUser(id);
    setBrokerDetails((prev) => ({
      ...prev,
      ...result,
    }));
  }, [id]);

  useEffect(() => {
    if (id) {
      fetchBroker();
    }
  }, [id]);

  return {
    id,
    brokerDetails,
    setBrokerDetails,
    fetchBroker,
  };
}
